<template>
  <div v-if="isDisplayTag" class="recommend-summary">
    <h3 v-if="isDisplayTitle">{{ title }}</h3>
    <ul>
      <li v-for="(tag, index) in tags" :key="index">
        <nuxt-link :to="url(tag.name)">{{ tag.name }}イベント会場</nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { createUrl } from '@/utils/create-url'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      required: true
    }
  },
  computed: {
    isDisplayTag() {
      return this.tags.length
    },
    isDisplayTitle() {
      return this.title.length >= 1
    }
  },
  methods: {
    url(tagName) {
      return createUrl.createSummaryUrl(tagName)
    }
  }
}
</script>
